export default "__VITE_ASSET__5ueHAtn9JtiQ3lCiqsnAfg__ 480w, __VITE_ASSET__V47HoeQBgiUEQbXS1PpE9g__ 745w";